import {API} from '../service/RESTService'

const DASHBOARD_ENDPOINT = "api/v1/dashboard/data"

export const getData = (idToken,params) => {
    return API.GET(DASHBOARD_ENDPOINT,idToken,params)
}